import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationBOS from './locales/bos/translation.json';
import translationENG from './locales/eng/translation.json';

const resources = {
  bos: {
    translation: translationBOS,
  },
  eng: {
    translation: translationENG,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'bos',
  fallbackLng: 'bos',

  keySeparator: false,

  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
